import { MainLayoutComponent } from '@components/main-layout/main-layout.component'
import { Routes } from '@angular/router'
import { AuthGuard } from 'src/app/guards/auth.guard'
import { NgxPermissionsGuard } from 'ngx-permissions'
import { MapAnalyticsComponent } from './map-analytics.component'

export const mapAnalyticsRoutes: Routes = [
  {
    path: 'map-analytics',
    component: MainLayoutComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: 'MAP_ANALYTICS_DASHBOARD',
        redirectTo: '/',
      },
    },
    children: [{ path: '', component: MapAnalyticsComponent }],
  },
]
